import { __extends } from "tslib";
import { Vector2 } from "../Maths/math.vector";
import { PostProcess } from "./postProcess";
import "../Shaders/stereoscopicInterlace.fragment";
/**
 * StereoscopicInterlacePostProcessI used to render stereo views from a rigged camera with support for alternate line interlacing
 */
var StereoscopicInterlacePostProcessI = /** @class */ (function (_super) {
    __extends(StereoscopicInterlacePostProcessI, _super);
    /**
     * Initializes a StereoscopicInterlacePostProcessI
     * @param name The name of the effect.
     * @param rigCameras The rig cameras to be appled to the post process
     * @param isStereoscopicHoriz If the rendered results are horizontal or vertical
     * @param isStereoscopicInterlaced If the rendered results are alternate line interlaced
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */
    function StereoscopicInterlacePostProcessI(name, rigCameras, isStereoscopicHoriz, isStereoscopicInterlaced, samplingMode, engine, reusable) {
        var _this = _super.call(this, name, "stereoscopicInterlace", ['stepSize'], ['camASampler'], 1, rigCameras[1], samplingMode, engine, reusable, isStereoscopicInterlaced ? "#define IS_STEREOSCOPIC_INTERLACED 1" : isStereoscopicHoriz ? "#define IS_STEREOSCOPIC_HORIZ 1" : undefined) || this;
        _this._passedProcess = rigCameras[0]._rigPostProcess;
        _this._stepSize = new Vector2(1 / _this.width, 1 / _this.height);
        _this.onSizeChangedObservable.add(function () {
            _this._stepSize = new Vector2(1 / _this.width, 1 / _this.height);
        });
        _this.onApplyObservable.add(function (effect) {
            effect.setTextureFromPostProcess("camASampler", _this._passedProcess);
            effect.setFloat2("stepSize", _this._stepSize.x, _this._stepSize.y);
        });
        return _this;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "StereoscopicInterlacePostProcessI" string
     */
    StereoscopicInterlacePostProcessI.prototype.getClassName = function () {
        return "StereoscopicInterlacePostProcessI";
    };
    return StereoscopicInterlacePostProcessI;
}(PostProcess));
export { StereoscopicInterlacePostProcessI };
/**
 * StereoscopicInterlacePostProcess used to render stereo views from a rigged camera
 */
var StereoscopicInterlacePostProcess = /** @class */ (function (_super) {
    __extends(StereoscopicInterlacePostProcess, _super);
    /**
     * Initializes a StereoscopicInterlacePostProcess
     * @param name The name of the effect.
     * @param rigCameras The rig cameras to be appled to the post process
     * @param isStereoscopicHoriz If the rendered results are horizontal or verticle
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */
    function StereoscopicInterlacePostProcess(name, rigCameras, isStereoscopicHoriz, samplingMode, engine, reusable) {
        var _this = _super.call(this, name, "stereoscopicInterlace", ['stepSize'], ['camASampler'], 1, rigCameras[1], samplingMode, engine, reusable, isStereoscopicHoriz ? "#define IS_STEREOSCOPIC_HORIZ 1" : undefined) || this;
        _this._passedProcess = rigCameras[0]._rigPostProcess;
        _this._stepSize = new Vector2(1 / _this.width, 1 / _this.height);
        _this.onSizeChangedObservable.add(function () {
            _this._stepSize = new Vector2(1 / _this.width, 1 / _this.height);
        });
        _this.onApplyObservable.add(function (effect) {
            effect.setTextureFromPostProcess("camASampler", _this._passedProcess);
            effect.setFloat2("stepSize", _this._stepSize.x, _this._stepSize.y);
        });
        return _this;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "StereoscopicInterlacePostProcess" string
     */
    StereoscopicInterlacePostProcess.prototype.getClassName = function () {
        return "StereoscopicInterlacePostProcess";
    };
    return StereoscopicInterlacePostProcess;
}(PostProcess));
export { StereoscopicInterlacePostProcess };
//# sourceMappingURL=stereoscopicInterlacePostProcess.js.map